import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'name',
    label: i18n('entities.packagingCertification.fields.name'),
    schema: schemas.string(
      i18n('entities.packagingCertification.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'logos',
    label: i18n('entities.packagingCertification.fields.logos'),
    schema: schemas.relationToMany(
      i18n('entities.packagingCertification.fields.logos'),
      {},
    ),
  },
  {
    name: 'infoMessage',
    label: i18n('entities.packagingCertification.fields.infoMessage'),
    schema: schemas.string(
      i18n('entities.packagingCertification.fields.infoMessage'),
      {},
    ),
  },
];